import {z} from '@hono/zod-openapi';

import {E164PhoneNumberSchema} from './E164PhoneNumberSchema';
import {VoiceTenantLanguageSchema} from './VoiceTenantLanguageSchema';

const VOICE_CALL_CONTEXT_REGISTERED_EVENT_SCHEMA_VERSION = '1.0.0';

/**
 * DMS -> Voice Gateway. Published to `VOICE_CALL_CONTEXT_TOPIC` after DMS resolves the called
 * number to a line, tenant, workspace, language and scenario, and before it returns TwiML
 * dialing OpenAI SIP with the same `callReference` in the `X-Omnetic-Call-Reference` SIP
 * header. The Gateway joins this event to `IncomingVoiceCallCommandSchema` by `callReference`;
 * either may arrive first. A context stops being valid at `expiresAt`.
 */
export const VoiceCallContextRegisteredEventSchema = z
  .object({
    schemaVersion: z.literal(VOICE_CALL_CONTEXT_REGISTERED_EVENT_SCHEMA_VERSION),
    eventType: z.literal('voice.call.context-registered'),
    callReference: z.string().uuid(),
    tenantId: z.string().min(1),
    workspace: z.string().min(1).nullable(),
    language: VoiceTenantLanguageSchema,
    scenarioId: z.string().min(1),
    scenarioVersion: z.number().int().positive().optional(),
    calledNumber: E164PhoneNumberSchema,
    callerNumber: E164PhoneNumberSchema.nullable(),
    lineId: z.string().min(1).optional(),
    registeredAt: z.string().datetime({offset: true}),
    expiresAt: z.string().datetime({offset: true}),
  })
  .strict()
  .openapi('VoiceCallContextRegisteredEventSchema');

export type VoiceCallContextRegisteredEvent = z.infer<typeof VoiceCallContextRegisteredEventSchema>;
